var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "renderer py-1 w-100" },
    _vm._l(_vm.channels, function (channel) {
      return _c("ChannelItem", { key: channel.id, attrs: { channel: channel } })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }